/*
	Define se estamos ou não carregando
*/
export default (state, loading=true) =>
	state.swagger.atendimentos.loading = loading
	